// PR-F — staff ACH mandate capture for a loan's buyer. The card captures a
// us_bank_account SetupIntent (Stripe-on-the-connected-account) so the buyer
// can later be billed off-session. The browser only ever sees the publishable
// key + a client secret; the connected-account id scopes the Elements session.
// Mutation/queries are local useState in the card — no TanStack hook needed.

import { api } from "../client";

/** GET — whether a confirmed bank mandate is on file for the loan's buyer. */
export interface AchMandateStatus {
  mandateOnFile: boolean;
  /** Stripe SetupIntent status (e.g. requires_payment_method | processing |
   *  succeeded), or null when no SetupIntent has been started. */
  status: string | null;
  bankLast4: string | null;
  confirmedAt: string | null;
}

/** POST begin — the SetupIntent the browser confirms with the Payment Element. */
export interface AchMandateSetupIntent {
  setupIntentId: string;
  clientSecret: string;
  publishableKey: string;
  /** The TPS's connected account the Elements session must be scoped to. */
  stripeAccount: string;
}

export interface BeginAchMandateRequest {
  /** Optional override for the buyer's email (e.g. a fresh contact). */
  buyerEmail?: string;
}

export const achMandateApi = {
  status: (loanId: string) =>
    api.get<AchMandateStatus>(`/portfolio-admin/loans/${loanId}/ach-mandate`),
  begin: (loanId: string, body?: BeginAchMandateRequest) =>
    api.post<AchMandateSetupIntent>(
      `/portfolio-admin/loans/${loanId}/ach-mandate`,
      body ?? {},
    ),
};
